import gql from 'graphql-tag';
import { mutation } from 'services/graphql';

export const ejectSurfaceNodeFromSurfaceProtocolNodeMutation = gql`
  mutation ejectSurfaceNodeFromSurfaceProtocolNode(
    $ejectInput: EjectSurfaceNodeFromSurfaceProtocolNodeInput!
    $positionInput: UpdateSurfaceNodePositionInput!
  ) {
    ejectSurfaceNodeFromSurfaceProtocolNode(input: $ejectInput) {
      success
      error
    }
    updateSurfaceNodePosition(input: $positionInput) {
      success
      error
    }
  }
`;

export default mutation(ejectSurfaceNodeFromSurfaceProtocolNodeMutation);
